var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", modalId: "modal-lv2", withBgClickEvent: true },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "flex justify-between items-center m-2 border-gray-300",
              },
              [
                _c("nav", { staticClass: "flex flex-row" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "text-gray-600 py-2.5 px-1 block mr-4 sm:mr-6 text-base hover:text-blue-500 focus:outline-none",
                      class: { activeClass: _vm.currentTab === "manager" },
                      on: {
                        click: function ($event) {
                          return _vm.setTab("manager")
                        },
                      },
                    },
                    [_vm._v(" Manager notes ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex gap-1 justify-center items-center" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "text-gray-600 py-2.5 px-1 block text-base hover:text-blue-500 focus:outline-none",
                          class: { activeClass: _vm.currentTab === "staff" },
                          on: {
                            click: function ($event) {
                              return _vm.setTab("staff")
                            },
                          },
                        },
                        [_vm._v(" Staff notes ")]
                      ),
                      _c(
                        "div",
                        [
                          _c("TabNotificationBubble", {
                            attrs: {
                              notification: _vm.totalStaffNotes.toString(),
                              info: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  { on: { click: _vm.closeModal } },
                  [
                    _c("CloseOutlinedGray", {
                      staticClass: "cursor-pointer w-4 h-4",
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm.currentTab === "manager"
              ? _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c("div", { staticClass: "mb-8" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "mb-0.5 text-xs font-normal text-storm-gray",
                        },
                        [_vm._v(" " + _vm._s(_vm.managerDate) + " ")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "text-base font-normal",
                          class: {
                            "text-storm-gray":
                              _vm.activity.extra_notes === "" ||
                              _vm.activity.extra_notes === null,
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.managerNote) + " ")]
                      ),
                    ]),
                    _c(
                      "UiButton",
                      {
                        staticClass: "flex justify-end text-sm font-normal",
                        attrs: {
                          variant: "black",
                          size: "sm",
                          buttonText: _vm.noBtnText,
                        },
                        on: { click: _vm.closeModal },
                      },
                      [_vm._v(" Close ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.currentTab === "staff"
              ? _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _vm.isResources
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex warningText justify-between items-center w-full",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-row items-center w-full",
                              },
                              [
                                _c("InfoCircleFilled", {
                                  staticClass: "w-4 h-4 mr-2",
                                }),
                                _c("p", [
                                  _vm._v(
                                    "Notes cannot be deleted or modified once posted"
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "button",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.isStaffNotesWarning = false
                                  },
                                },
                              },
                              [
                                _c("CloseOutlinedGray", {
                                  staticClass: "w-4 h-4",
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "max-h-1/2" }, [
                      _vm.notes.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "overflow-y-scroll custom-scrollbar",
                            },
                            _vm._l(_vm.notes, function (note) {
                              return _c("ContractorStaffNotesCard", {
                                key: note,
                                attrs: { note: note },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      !_vm.isResources && _vm.notes.length === 0
                        ? _c("div", [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-base text-storm-gray font-normal",
                              },
                              [
                                _vm._v(
                                  "There are currently no notes from staff"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.isResources
                      ? _c(
                          "FormGroup",
                          [
                            _c("FormTextarea", {
                              staticClass: "activeBox my-5",
                              attrs: {
                                customBorderClass: "borderTen",
                                rows: 3,
                                placeholder: "Tap to type...",
                                required: "",
                              },
                              model: {
                                value: _vm.staffNote,
                                callback: function ($$v) {
                                  _vm.staffNote = $$v
                                },
                                expression: "staffNote",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "flex flex-row justify-end gap-2" },
                      [
                        _c(
                          "UiButton",
                          {
                            staticClass: "flex justify-end text-sm font-normal",
                            attrs: {
                              variant: "outline-black",
                              size: "sm",
                              buttonText: _vm.noBtnText,
                            },
                            on: { click: _vm.closeModal },
                          },
                          [_vm._v(" Close ")]
                        ),
                        _vm.isResources
                          ? _c(
                              "UiButton",
                              {
                                staticClass:
                                  "flex justify-end text-sm font-normal",
                                attrs: {
                                  size: "sm",
                                  variant: "black",
                                  buttonText: _vm.noBtnText,
                                  disabled: !_vm.staffNote.trim(),
                                },
                                on: { click: _vm.saveNote },
                              },
                              [_vm._v(" Post ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }